import React, {useState, useEffect, useRef} from 'react'
import {sha256} from "js-sha256";
import ServerSelect from "./components/ServerSelect";
import FormLogin from "./components/Form";
import axios from "axios";
import {Error} from "../../../components/Error/Error";
import SingleInputForm from './components/SingleInputForm';
import login from "../Login";
import {useInterval} from "../../../helpers";

const EMAIL_TIMEOUT = 60;
const LoginForm = (props: { resetPassword: (arg0: boolean) => void; }) => {

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [cid, setCID] = useState("");
    const [beta, setBeta] = useState(false);

    const [loginJourneyState, setLoginJourneyState] = useState("journey_login");
    const [email, setEmail] = useState("");
    const [verificationCode, setVerificationCode] = useState("");
    const [emailTimeout, setEmailTimeout] = useState(EMAIL_TIMEOUT);

    const [errorMsg, setErrorMsg] = useState("");

    const onLoginFormSubmit = async () => {
        if (!username || !password || !cid)
            console.log('failed login');
        else {


            // normal or enterprise only
            if(!['ninja','atlantis','admin','ameego','cinternal','live','d-admin','thrive'].includes(cid.toLowerCase())){
                const loginResponse = await tryLogin(username,password,cid);
                if(!loginResponse){
                    return;
                }

                if(loginResponse['user_status'] == 'email-verified'
                || loginResponse['user_status'] == 'email-verification-not-required'){
                    return loginRedirect();
                }

                setEmail(loginResponse['email']);
                setLoginJourneyState("journey_confirm_user_email");
                return;
            }
            else {
                return loginRedirect();
            }

        }
    }

    const BASE_URL = 'https://c.myameego.com';
    const loginRedirect = () => {
        let dest = "c";
        let newCid = cid;
        // const notBetaCidList:Array<number> = [103152, 3166, 3143, 2967, 2897, 2893, 2880, 2603]; // TODO: Add Beta test CIDS here.
        // const nonIntBetaCidList:Array<string> = ["enterprise", "enterpriseuser", "ninja", "atlantis", "admin", "ameego", "cinternal", "live", "d-admin"];
        //
        // if (!notBetaCidList.includes(parseInt(cid)) && !nonIntBetaCidList.includes(cid.toLowerCase())) {
        //     setBeta(true);
        // } else {

        if (cid === 'ninja') {
            dest = "n";
            newCid = 'ameego';
        }

        if (cid === "atlantis") {
            dest = "a";
            newCid = 'ameego';
        }

        if (cid == 'enterpriseuser') {
            newCid = 'enterprise';
        }

        if (cid === 'admin' || cid === "ameego") {
            dest = 'admin';
            newCid = 'ameego';
        }

        if (cid === 'cinternal') {
            dest = 'cinternal';
            newCid = 'ameego';
        }

        if (cid === 'live') {
            dest = 'live';
            newCid = 'ameego';
        }

        if (cid === 'd-admin') {
            dest = 'd';
            newCid = 'ameego';
        }

        let url = "";

        if (dest === "n")
            url = "https://n.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else if (dest === "admin")
            url = "https://admin.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else if (dest === "cinternal")
            url = "https://cinternal.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else if (dest === "live")
            url = "https://c.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else if(dest === "a")
            url = "https://a.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else if(dest === "d")
            url = "https://d.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid
        else
            url = BASE_URL+"/core/login.php?submit&f&username=" + username + "&password=" + sha256(password) + "&client_id=" + newCid

        if (cid === 'thrive') {
            url = "https://c.myameego.com/core/login.php?submit&f&username=" + username + "&password=" + btoa(password) + "&client_id=" + newCid
        }


        window.location.href=url;
    }


    const errMsg = errorMsg ? <Error strongText={"Error:"} text={errorMsg}/>:<></>;

    const tryLogin = async (username: string, password: string, cid: string) => {
        return await axios.post(BASE_URL + '/core/node_api/v2/login/?path=try-login', {
            "username": username,
            "password":password,
            "client_id": cid
        })
            .then(function (response) {
                setErrorMsg("");
                return response.data.data;
            })
            .catch(function (error) {
                console.log(error);
                setErrorMsg(error.response.data.message);
                return null;
            });
    }

    const submitEmail = async (username: string, password: string, cid: string, email: string) => {
        return await axios.post(BASE_URL + '/core/node_api/v2/login/?path=add-email', {
            "username": username,
            "password":password,
            "client_id": cid,
            "email": email
        })
            .then(function (response) {
                setErrorMsg("");
                return response.data.data;
            })
            .catch(function (error) {
                setErrorMsg(error.response.data.message);
                return null;
            });
    }

    const submitVerifyEmail = async (username: string, password: string, cid: string, email: string, email_verification_code: string) => {
        return await axios.post(BASE_URL + '/core/node_api/v2/login/?path=verify-email', {
            "username": username,
            "password":password,
            "client_id": cid,
            "email": email,
            "email_verification_code": email_verification_code
        })
            .then(function (response) {
                setErrorMsg("");
                return response.data.data;
            })
            .catch(function (error) {
                setErrorMsg(error.response.data.message);
                return null;
            });
    }

    const validateEmail = (email:string) => {
        return String(email)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            );
    };


    useInterval(() => {
        if(loginJourneyState == 'journey_verify_email_code'){
            if(emailTimeout > 0){
                setEmailTimeout(emailTimeout - 1);
            }
        }
    }, 1000);

    const onEmailConfirmationSubmit = async () => {
        if(validateEmail(email)){
            const emailSubmitResponse = await submitEmail(username,password,cid,email);

                if(!emailSubmitResponse){
                    console.log("Submit email failed!");
                    return;
                }

                setEmailTimeout(EMAIL_TIMEOUT);
                setLoginJourneyState("journey_verify_email_code");

                return;
        }
    };

    const onEmailVerificationCodeSubmit = async () => {
        const verifyEmailResponse = await submitVerifyEmail(username,password,cid,email,verificationCode);

        if(!verifyEmailResponse){
            return;
        }
        setLoginJourneyState("journey_email_verified");
        return;
    };

    const resendEmailButton = () => {
        if(emailTimeout > 0){
            return <>Please wait {emailTimeout} seconds</>
        }
        return <a href="#" className='link' onClick={onEmailConfirmationSubmit}>Resend Email</a>;
    }

    const loginFormDynamicElem = () => {
        switch (loginJourneyState) {
            case 'journey_confirm_user_email':
                return <>
                    <SingleInputForm
                    input={email} setInput={setEmail} inputType="email" inputName="email"
                    prompt="Please enter/confirm your Email:" required={true}
                    onSubmit={onEmailConfirmationSubmit}
                    />
                <div className="info">If you change your email here, your email in your ameego employee profile will also be updated.</div>

            </>
            case 'journey_verify_email_code':
                return <>
                    <SingleInputForm
                        input={verificationCode} setInput={setVerificationCode} inputType="text" inputName="verification_code"
                        prompt={"Enter the verification code that was sent to your email: (" + email + ")"} required={true}
                        onSubmit={onEmailVerificationCodeSubmit}
                    />
                    <br/>
                    <span>Did not receive any email?</span> {resendEmailButton()}
                    </>;
            case 'journey_email_verified':
                return loginRedirect();
            default:
                return <FormLogin setUsername={setUsername} setPassword={setPassword} setCID={setCID} onFormSubmit={onLoginFormSubmit} resetPassword={props.resetPassword}></FormLogin>;

        }
    }

    const loginFormHTML = (beta) ? (
        <>
            <ServerSelect username={username} password={password} cid={cid} beta={setBeta}/>
        </>)
        : (
        <>
            {loginFormDynamicElem()}
            {errMsg}
        </>
    )

    return (
        <>
            {loginFormHTML}
        </>
    );
}

export default LoginForm;